import { render, staticRenderFns } from "./xc-base_form_dialog.vue?vue&type=template&id=6059214c&scoped=true"
import script from "./xc-base_form_dialog.vue?vue&type=script&lang=js"
export * from "./xc-base_form_dialog.vue?vue&type=script&lang=js"
import style0 from "./xc-base_form_dialog.vue?vue&type=style&index=0&id=6059214c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6059214c",
  null
  
)

export default component.exports